import React from "react";
import { Navigate, Route } from "react-router-dom";
import PlatformLayout from "./PlatformLayout";

const PlatformLogin = React.lazy(() => import("./PlatformLogin"));
const Dashboard = React.lazy(() => import("./Dashboard"));
const Marketing = React.lazy(() => import("./Marketing"));
const Staff = React.lazy(() => import("./Staff"));
const Users = React.lazy(() => import("./Users"));
const Clans = React.lazy(() => import("./Clans"));
const Vendors = React.lazy(() => import("./Vendors"));
const Products = React.lazy(() => import("./Products"));
const Plans = React.lazy(() => import("./Plans"));
const Subscriptions = React.lazy(() => import("./Subscriptions"));
const Domains = React.lazy(() => import("./Domains"));
const Logs = React.lazy(() => import("./Logs"));
const Settings = React.lazy(() => import("./Settings"));

function PlatformSuspense({ children }) {
  return (
    <React.Suspense
      fallback={
        <div style={{ padding: 32, color: "#6f6068", fontFamily: '"Be Vietnam Pro", sans-serif' }}>
          Loading platform surface...
        </div>
      }
    >
      {children}
    </React.Suspense>
  );
}

export const platformRoutes = (
  <>
    <Route
      path="login"
      element={
        <PlatformSuspense>
          <PlatformLogin />
        </PlatformSuspense>
      }
    />
    <Route element={<PlatformLayout />}>
      <Route
        index
        element={
          <PlatformSuspense>
            <Dashboard />
          </PlatformSuspense>
        }
      />
      <Route
        path="marketing"
        element={
          <PlatformSuspense>
            <Marketing />
          </PlatformSuspense>
        }
      />
      <Route
        path="staff"
        element={
          <PlatformSuspense>
            <Staff />
          </PlatformSuspense>
        }
      />
      <Route
        path="users"
        element={
          <PlatformSuspense>
            <Users />
          </PlatformSuspense>
        }
      />
      <Route
        path="clans"
        element={
          <PlatformSuspense>
            <Clans />
          </PlatformSuspense>
        }
      />
      <Route
        path="vendors"
        element={
          <PlatformSuspense>
            <Vendors />
          </PlatformSuspense>
        }
      />
      <Route
        path="products"
        element={
          <PlatformSuspense>
            <Products />
          </PlatformSuspense>
        }
      />
      <Route
        path="plans"
        element={
          <PlatformSuspense>
            <Plans />
          </PlatformSuspense>
        }
      />
      <Route
        path="subscriptions"
        element={
          <PlatformSuspense>
            <Subscriptions />
          </PlatformSuspense>
        }
      />
      <Route
        path="domains"
        element={
          <PlatformSuspense>
            <Domains />
          </PlatformSuspense>
        }
      />
      <Route
        path="logs"
        element={
          <PlatformSuspense>
            <Logs />
          </PlatformSuspense>
        }
      />
      <Route
        path="settings"
        element={
          <PlatformSuspense>
            <Settings />
          </PlatformSuspense>
        }
      />
    </Route>
    {/* Catch-all for unmatched /app/<x> — redirect to the platform
        dashboard instead of falling through to the :tenantSlug matcher
        in router.jsx (which would capture "app" as a tenant slug). Must
        stay LAST so specific child routes above still match first. */}
    <Route path="*" element={<Navigate to="/app" replace />} />
  </>
);

export { default as PlatformLayout } from "./PlatformLayout";
